import React, { useState, useEffect } from "react";
import { Create, Form, Input, DatePicker, useForm, Select, Checkbox } from "@pankod/refine-antd";
import { useNavigation, usePermissions } from "@pankod/refine-core";
import { notification } from "@pankod/refine-antd";
import axios from "@pankod/refine-simple-rest/node_modules/axios";
import { API_URL, TOKEN_KEY } from "../../constants/environment";
import { IRentPlace, RentPlaceStatusEnum } from "../../interfaces/rent-place.interface";
import { placeOptions, getAllowedPlaces, rentPlaceStatusOptions } from "../../constants/rentPlace.constants";
import { CustomTimePicker } from "../../components/atoms/custom-time-picker";
import dayjs from "dayjs";

export const RentPlaceCreate: React.FC = () => {
    const { formProps, saveButtonProps, form } = useForm<IRentPlace>();
    const { push } = useNavigation();
    const { data: permissionsData } = usePermissions();
    
    const [startTime, setStartTime] = useState("09:00");
    const [endTime, setEndTime] = useState("10:00");

    // Filtrar lugares según permisos del usuario
    const isAdmin = permissionsData?.includes('rent-places:admin');
    const allowedPlaces = getAllowedPlaces(permissionsData || []);
    const filteredPlaceOptions = placeOptions.filter(option => 
        isAdmin || allowedPlaces.includes(option.value)
    );

    // Establecer lugar por defecto si solo tiene permisos para uno
    useEffect(() => {
        if (filteredPlaceOptions.length === 1 && form) {
            form.setFieldsValue({
                place: filteredPlaceOptions[0].value
            });
        }
    }, [filteredPlaceOptions, form]);

    const onFinish = async (values: any) => {
        const payload = {
            start_date: typeof values.start_date === "string" ? dayjs(values.start_date, "DD/MM/YYYY").format("YYYY-MM-DD") : values.start_date.format("YYYY-MM-DD"),
            end_date: typeof values.start_date === "string" ? dayjs(values.start_date, "DD/MM/YYYY").format("YYYY-MM-DD") : values.start_date.format("YYYY-MM-DD"),
            start_time: startTime,
            end_time: endTime,
            place: values.place || "",
            receipt_number: values.receipt_number || "",
            institution: values.institution || "",
            event_name: values.event_name || "",
            responsible_name: values.responsible_name || "",
            responsible_phone: values.responsible_phone || "",
            observations: values.observations || "",
            is_free: values.is_free || false,
        };

        const token = localStorage.getItem(TOKEN_KEY);
        try {
            await axios.post(`${API_URL}/rent-places`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    ...(token ? { Authorization: `Bearer ${token}` } : {}),
                },
            });
            notification.success({
                message: "Renta de lugar guardada correctamente",
                description: "El registro fue creado exitosamente.",
            });
            push("/rent-places");
        } catch (error: any) {
            notification.error({
                message: "Error al guardar",
                description: error?.response?.data?.message || "Ocurrió un error al guardar la renta de lugar.",
            });
        }
    };

    return (
        <Create saveButtonProps={saveButtonProps} title={"Crear Renta de Lugar"}>
            <Form {...formProps} layout="vertical" onFinish={onFinish}>
                <Form.Item name="start_date" label="Fecha de Inicio" rules={[{ required: true }]}> 
                    <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item label="Hora de inicio" rules={[{ required: true }]}>
                    <CustomTimePicker
                        value={startTime}
                        onChange={setStartTime}
                        placeholder="Seleccionar hora de inicio"
                    />
                </Form.Item>
                <Form.Item label="Hora de fin" rules={[{ required: true }]}>
                    <CustomTimePicker
                        value={endTime}
                        onChange={setEndTime}
                        placeholder="Seleccionar hora de fin"
                    />
                </Form.Item>
                <Form.Item name="place" label="Lugar" rules={[{ required: true }]}>
                    <Select
                        options={filteredPlaceOptions}
                        placeholder={filteredPlaceOptions.length === 1 ? filteredPlaceOptions[0].label : "Selecciona un lugar"}
                        showSearch
                        optionFilterProp="label"
                        disabled={filteredPlaceOptions.length === 1}
                    />
                </Form.Item>
                <Form.Item name="receipt_number" label="Número de Recibo" rules={[{ required: false }]}>
                    <Input placeholder="Número de recibo" />
                </Form.Item>
                <Form.Item name="institution" label="Institución" rules={[{ required: false }]}>
                    <Input placeholder="Nombre de la institución" />
                </Form.Item>
                <Form.Item name="event_name" label="Nombre del Evento" rules={[{ required: true }]}>
                    <Input placeholder="Nombre del evento" />
                </Form.Item>
                <Form.Item name="responsible_name" label="Nombre del Responsable" rules={[{ required: true }]}>
                    <Input placeholder="Nombre completo del responsable" />
                </Form.Item>
                <Form.Item name="responsible_phone" label="Celular del Responsable" rules={[{ required: true }]}>
                    <Input placeholder="Número de celular" />
                </Form.Item>
                <Form.Item name="is_free" valuePropName="checked" label="">
                    <Checkbox>Evento Gratuito</Checkbox>
                </Form.Item>
                <Form.Item name="observations" label="Observaciones">
                    <Input.TextArea rows={3} placeholder="Observaciones adicionales (opcional)" />
                </Form.Item>
            </Form>
        </Create>
    );
};

export default RentPlaceCreate;
